import React, { useCallback, useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { DeckNav } from './DeckNav';
import { DECK_UNLOCK_STORAGE_KEY, EmailGate } from './EmailGate';
import { SlideView } from './SlideView';
import { slides } from './slides';
const isMagicPatternsPreview = () => {
  const host = window.location.hostname;
  return host === 'magicpatterns.com' || host.endsWith('.magicpatterns.com') || host.endsWith('.magicpatterns.app');
};
const PREVIEW_MODE = isMagicPatternsPreview();
export function Deck() {
  const [index, setIndex] = useState(0);
  const [isUnlocked, setIsUnlocked] = useState(PREVIEW_MODE);
  const [isGateOpen, setIsGateOpen] = useState(false);
  const total = slides.length;
  useEffect(() => {
    if (PREVIEW_MODE) return;
    setIsUnlocked(localStorage.getItem(DECK_UNLOCK_STORAGE_KEY) === 'true');
  }, []);
  const goTo = useCallback((requestedIndex: number) => {
    const nextIndex = Math.max(0, Math.min(total - 1, requestedIndex));
    if (nextIndex === index) return;
    if (!isUnlocked && nextIndex > 0) {
      setIsGateOpen(true);
      return;
    }
    setIndex(nextIndex);
  }, [index, isUnlocked, total]);
  const next = useCallback(() => goTo(index + 1), [goTo, index]);
  const prev = useCallback(() => goTo(index - 1), [goTo, index]);
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (isGateOpen) {
        if (event.key === 'Escape') setIsGateOpen(false);
        return;
      }
      if (event.key === 'ArrowRight' || event.key === 'PageDown') next();else if (event.key === 'ArrowLeft' || event.key === 'PageUp') prev();else if (event.key === 'Home') goTo(0);else if (event.key === 'End') goTo(total - 1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isGateOpen, next, prev, goTo, total]);
  const handleUnlock = () => {
    setIsUnlocked(true);
    setIsGateOpen(false);
    setIndex(1);
  };
  const slide = slides[index];
  return <main className="relative flex min-h-screen w-full flex-col bg-bg" data-id="element-1" data-mp="39gz4nsi2aypm">
      <header className="pointer-events-none fixed inset-x-0 top-0 z-20 flex items-center justify-between border-b border-white/[0.06] bg-bg px-5 py-5 sm:px-8" data-id="element-2" data-mp="3ee8rr1hzayaa">
        <div className="flex items-center gap-2.5" data-id="element-3" data-mp="34ph0kvkqsi0f">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent/15 ring-1 ring-accent/30" data-id="element-4" data-mp="34nw7zbhzn957">
            <span className="h-3 w-3 rounded-sm bg-accent" data-id="element-5" data-mp="2qrsifvi27oz2" />
          </span>
          <span className="text-sm font-bold tracking-tight text-white" data-id="element-6" data-mp="2vpkcav29ll5w">
            Open<span className="text-accent" data-id="element-7" data-mp="2gsbg9o20nt7u">FPGA</span>
          </span>
        </div>
        <span className="hidden font-mono text-xs uppercase tracking-[0.2em] text-slate-500 sm:block" data-id="element-8" data-mp="2lq35297d6z7t">
          Seed Deck · 2026
        </span>
      </header>

      <div aria-hidden className="pointer-events-none fixed inset-0 opacity-[0.4]" style={{
      backgroundImage: 'radial-gradient(circle at 50% 0%, rgba(45,212,167,0.05), transparent 55%)'
    }} data-id="element-9" data-mp="ey2d19kagumt" />

      <div className="flex flex-1 items-center pb-28 pt-20" data-id="element-10" data-mp="1ziz3d0oriy67">
        <AnimatePresence mode="wait" data-id="element-11" data-mp="1zgcvezxymgng">
          <SlideView key={slide.id} slide={slide} index={index} data-id="element-12" data-mp="2e7dcftcrviv7" />
        </AnimatePresence>
      </div>

      <DeckNav slides={slides} index={index} onPrev={prev} onNext={next} onGoTo={goTo} data-id="element-13" data-mp="29fc6sqa40qe5" />

      <EmailGate isOpen={isGateOpen} onClose={() => setIsGateOpen(false)} onUnlock={handleUnlock} data-id="element-14" data-mp="2n5yw5rtzd3xk" />
    </main>;
}